import React from "react";
import { Route, Routes } from "react-router";
import ServiceHistoryList from "./List";
import ServiceHistoryDetails from "./Details";

const ServiceHistory: React.FC = () => (
    <Routes>
        <Route index element={<ServiceHistoryList />} />
        <Route path=":id" element={<ServiceHistoryDetails />} />
    </Routes>
);

export default ServiceHistory;
